exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.prescriptions-checkbox-wrapper[data-v-733685bc] .v-input__slot {\n  margin-bottom: 0;\n}\n.prescriptions-checkbox-wrapper[data-v-733685bc] .v-messages {\n  display: none;\n}\n", ""]);

// exports
